import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '#environments';
import { AgentRun, RerunAgentRunRequest, RerunAgentRunResult } from '#models';

@Injectable({ providedIn: 'root' })
export class AgentRunService {
  private _http = inject(HttpClient);

  getAll(): Observable<AgentRun[]> {
    if (environment.useMockData) {
      return of([]);
    }
    return this._http.get<AgentRun[]>(`${environment.apiUrl}/agentrun`);
  }

  rerun(request: RerunAgentRunRequest): Observable<RerunAgentRunResult> {
    return this._http.post<RerunAgentRunResult>(`${environment.apiUrl}/agentrun/rerun`, request);
  }
}
